import { AbstractImmutableValueMessage } from "./abstractImmutableValueMessage";

export class ReadOnlyParamMessage extends AbstractImmutableValueMessage {
  
}